import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import { useLocation } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import Header from '../Components/Header';
import axios from 'axios';

function ClientDetails() {
    const authToken = sessionStorage.getItem('authToken');
    const baseurl = process.env.REACT_APP_BASE_API_URL;
    const [userData, setUserData] = useState([]);
    const [accessKey, setAccessKey] = useState([]);
    const [userWallet, setUserWallet] = useState([]);
    const [stakes, setStakes] = useState([]);
    const [deposits, setDeposits] = useState([]);
    const [withdraws, setWithdraw] = useState([]);
    const [isWalletUpdate, setWalletUpdatw] = useState(false);
    const user_id = sessionStorage.getItem("clientId");
    const [status, setStatus] = useState("");
    const [fees, setFees] = useState("");
    const [remark, setRemark] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [wallet_id, setWalletID] = useState(null);
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [tabelLoading, setTableLoading] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState("");
    const [minWithdraw, setMinWithdraw] = useState(0);
    const [maxWithdraw, setMaxWithdraw] = useState(0);

    const [editName, setEditName] = useState("")
    const [editEmail, setEditEmail] = useState("")
    const [editMobile, setEditMobile] = useState("")
    const [fundAmount, setFundAmount] = useState("")

    useEffect(() => {



        fetchProfileData();
    }, []);

    const fetchProfileData = async () => {
        //   console.log('Token ', authToken);
        try {
            const client = await fetch(`${baseurl}/client/details?user_id=${user_id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (client.status === 429) {
                // console.error("Rate limit exceeded. Please try again later.");
                return; // Stop further processing
            }

            const clientResult = await client.json();
            //   console.log('Static data', clientResult.data);

            if (clientResult.status) {
                setUserData(clientResult.data);
                setStakes(clientResult.stakes)
                setDeposits(clientResult.deposits)
                setWithdraw(clientResult.withdraws)
                setTableLoading(true)
            } else {
                // console.error("Error fetching clients:", clientResult.message);
                setTableLoading(true)
            }
        } catch (error) {
            // console.error('Fetch error:', error);
            setTableLoading(true)
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(""); // Clear previous errors

        if (!editName) return toast.error("Please Enter Name.");
        if (!editEmail) return toast.error("Pleae enter email.");
        if (!editMobile) return setError("Please enter Mobile.");

        const user_id = userData.id;
        const formData = {
            user_id: user_id,
            name: editName,
            email: editEmail,
            mobile: editMobile
        };


        try {
            const response = await fetch(`${baseurl}/user/edit`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json(); // Get raw response
            //   console.log("Raw API Response:", data); // Log response before parsing

            if (data.status) {
                toast.success(data.message)
                fetchProfileData();
            }
            else {
                toast.error(data.message)

            }
        } catch (error) {
            console.error("Fetch error:", error);
            setError("Network error. Please check your connection and try again.");
            toast.error("Network error. Please check your connection and try again.");
        }
    };


    const handleWalletClick = (id) => {
        setWalletUpdatw(prev => !prev);
        setWalletID(id);
    };

    const updateWalletStatus = async (e) => {
        e.preventDefault();
        setError(""); // Clear previous errors

        // **Field validation**
        if (!status) return setError("Please select a status.");
        if (!fees) return setError("Fees cannot be empty.");
        if (!password.trim()) return setError("Password is required.");
        if (!minWithdraw) return setError("Min Withdraw is required.");
        if (!maxWithdraw) return setError("Max Withdraw is required.");
        if (!wallet_id) return setError("Wallet ID is missing.");
        if (!authToken) return setError("Authentication token is missing.");

        const walletIdString = wallet_id ? wallet_id.toString() : ""; // Ensure it's a string safely

        const formData = {
            wallet_id: walletIdString,
            status,
            fees,
            password,
            min_withdraw: minWithdraw,
            max_withdraw: maxWithdraw
        }; // Added password safely
        // console.log("Sending Data:", formData);

        try {
            const walletResponse = await fetch(`${baseurl}/client/wallet/asset/update`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify(formData),
            });



            const walletData = await walletResponse.json();
            // console.log("Raw API Response:", walletData);

            if (walletData.status) {
                toast.success(walletData.message);
                window.location.href = ""
            } else {
                toast.error(walletData.status);
            }
        } catch (error) {
            //  console.error("Fetch error:", error);
            setError("Network error. Please check your connection and try again.");
            toast.error("Network error. Please check your connection and try again.");
        }
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setImage(file);
    };


    const handleSubmitImage = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        if (!image) {
            setError("Please select an image to upload.");
            setLoading(false);
            return;
        }

        if (!wallet_id) {
            setError("Wallet ID is missing.");
            setLoading(false);
            return;
        }

        const formData = new FormData();
        formData.append("wallet_id", wallet_id.toString()); // Ensure wallet_id is a string
        formData.append("asset_image", image); // Append image properly

        //  console.log("Form Data:", formData);

        try {
            const response = await fetch(`${baseurl}/client/wallet/asset/update-logo`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${authToken}`, // Authentication token
                },
                body: formData, // Send formData
            });

            let result;
            try {
                result = await response.json(); // Parse JSON safely
            } catch (jsonError) {
                throw new Error("Invalid JSON response from server.");
            }

            // console.log("Image Upload Response:", result);

            if (response.ok && result?.status) {
                toast.success("Image uploaded successfully!");
                window.location.href = "";
            } else {
                setError(result?.message || "Failed to upload image.");
            }
        } catch (error) {
            //   console.error("Upload error:", error);
            setError(error.message || "Network error. Please try again.");
        } finally {
            setLoading(false);
        }
    };







    const passEditData = () => {
        setEditName(userData.name);
        setEditEmail(userData.email);
        setEditMobile(userData.mobile);
    }


    const handelFund = async (e) => {
        alert(e) // prevent default form behavior if needed

        // Example data — replace with your actual values or state
        const payload = {
            user_id: userData.id,  // replace with actual user_id
            amount: fundAmount,         // replace with actual amount
            type: e          // or "deduct"
        };

        try {
            const response = await axios.post(`${baseurl}/fund-adjust`, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`,  // include if auth is needed
                    "Content-Type": "application/json"
                }
            });

            if (response.data.status) {
                alert("Success: " + response.data.message);
                fetchProfileData();
            } else {
                alert("Failed: " + response.data.message);
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Error: " + (error.response?.data?.message || error.message));
        }
    };

    const loginAsUser = async () => {
        const userId = sessionStorage.getItem("clientId");
        console.log(userId);


        try {
            const response = await fetch(`${baseurl}/login-as-user`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify({ user_id: userId }),
            });

            const data = await response.json(); // Get raw response

            if (data.status === true) {
                window.open(
                    `https://user.reliableandsecureinvestment.com/#/login?auth=${data.token}`,
                    "_blank" // Opens in a new tab/window
                );
            } else {
                toast.error(data.message);
            }

        } catch (error) {
            console.error("Fetch error:", error);
            setError("Network error. Please check your connection and try again.");
            toast.error("Network error. Please check your connection and try again.");
        }

    }
    return (
        <>
            <Header>
                <Auth />
                <div className="main-content app-content">
                    <div className="container-fluid">
                        {/* Page Header */}
                        <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
                            <div>
                                <h4 className="mb-0">Hi, welcome back!</h4>
                            </div>
                        </div>
                        {/* End Page Header */}

                        {/* Table Section */}
                        <div className="row row-sm">
                            <div className="col-xl-4">
                                <div className="card mb-4">
                                    <div className="card-body">
                                        <div className="ps-0">
                                            {tabelLoading ? (
                                                <div className="main-profile-overview">

                                                    <div className="row">
                                                        <div className="col-xl-12 text-center">
                                                            <span className="avatar avatar-xxl avatar-rounded main-img-user profile-user user-profile ">
                                                                <img src={userData.profile_image} alt="" className="profile-img" />

                                                            </span>
                                                            <div className=" mb-4">
                                                                <div className="text-center">
                                                                    <h5 className="main-profile-name">{userData.name || 'N/A'}</h5>
                                                                    <p className="main-profile-name-text text-muted">{userData.email || 'N/A'}</p>
                                                                </div>

                                                                {/* main-profile-bio */}
                                                                <hr className="border-1 mt-5" />
                                                                <div className="row">
                                                                    <div className="col-md-4 col mb20">
                                                                        <h5 className="fs-17">{userData.my_referral || '0'}</h5>
                                                                        <h6 className="text-small text-muted fs-14 mb-0">Direct</h6>
                                                                    </div>
                                                                    <div className="col-md-4 col mb20">
                                                                        <h5 className="fs-17">{userData.my_active || '0'}</h5>
                                                                        <h6 className="text-small text-muted fs-14 mb-0">Active</h6>
                                                                    </div>
                                                                    <div className="col-md-4 col mb20">
                                                                        <h5 className="fs-17">{userData.total_team || '0'}</h5>
                                                                        <h6 className="text-small text-muted fs-14 mb-0">Team</h6>
                                                                    </div>
                                                                </div>


                                                            </div>
                                                        </div>

                                                        <div className="col-xl-8">
                                                            <label className="main-content-label fs-13 mb-4">Information</label>
                                                            <div className="main-profile-social-list">
                                                                <div className="media">
                                                                    <div className="media-icon bg-primary-transparent text-primary">
                                                                        <i className="fa fa-mobile" />
                                                                    </div>
                                                                    <div className="media-body">
                                                                        <span>Contact Number</span>{" "}
                                                                        <a href="javascript:void(0);" className="text-primary">{userData.mobile || 'N/A'}</a>
                                                                    </div>
                                                                </div>
                                                                <div className="media">
                                                                    <div className="media-icon bg-success-transparent text-success">
                                                                        <i className="fa fa-envelope" />
                                                                    </div>
                                                                    <div className="media-body">
                                                                        <span>Email</span>{" "}
                                                                        <a href="javascript:void(0);" className="text-primary">
                                                                            {userData.email || 'N/A'}
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                                <div className="media">
                                                                    <div className="media-icon bg-info-transparent text-info">
                                                                        <i className="fa fa-key" />
                                                                    </div>
                                                                    <div className="media-body">
                                                                        <span>User ID</span>
                                                                        <a href="javascript:void(0);" className="text-primary">
                                                                            {userData && userData.my_code ? userData.my_code : 'N/A'}
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                                <div className="media">
                                                                    <div className="media-icon bg-danger-transparent text-danger">
                                                                        <i className="icon ion-md-link" />
                                                                    </div>
                                                                    <div className="media-body">
                                                                        <span>Register Date</span>
                                                                        <span>{userData.created_at ? userData.created_at.slice(0, 16) : 'N/A'}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <hr className="border-0" />



                                                        </div>
                                                    </div>

                                                    <div className="d-grid gap-2  mx-auto">
                                                        <button className="btn btn-primary btn-wave waves-effect waves-light" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={passEditData}>Edit</button>
                                                    </div>

                                                    <div className="d-grid gap-2  mt-3 mx-auto">
                                                        <button className="btn btn-danger btn-wave waves-effect waves-light" onClick={loginAsUser}>Login as user</button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="text-center">
                                                    <div class="d-flex justify-content-center mb-4">
                                                        <div class="spinner-border" role="status">
                                                            <span class="visually-hidden">Loading...</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {/* main-profile-overview */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-8">
                                <div className="row row-sm">
                                    <div className="col-sm-12 col-lg-12 col-md-12">
                                        <div className="card ">
                                            <div className="card-body">
                                                <div className="counter-status d-flex md-mb-0">
                                                    <div className="counter-icon bg-primary-transparent">
                                                        <i className="icon-layers text-primary" />
                                                    </div>
                                                    <div className="ms-auto">
                                                        <h5 className="fs-13">Avl Amount</h5>
                                                        <h2 className="mb-0 fs-22 mb-1 mt-1">$ {Number(userData.available_amount || 0).toFixed(2)}</h2>

                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <hr />
                                                    <div className="col-12 col-md-6 col-xl-6">
                                                        <input type="number" value={fundAmount} onChange={(e) => setFundAmount(e.target.value)} className="form-control" placeholder="Enter Amount" />

                                                    </div>
                                                    <div className="col-12 col-md-6 col-xl-6 text-end">
                                                        <button className="btn btn-sm btn-primary btn-wave waves-effect waves-light" onClick={() => handelFund('add')}>+Add</button>  <button className="btn btn-sm btn-danger btn-wave waves-effect waves-light" onClick={() => handelFund('deduct')}>-Remove</button>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-4 col-md-12">
                                        <div className="card ">
                                            <div className="card-body">
                                                <div className="counter-status d-flex md-mb-0">
                                                    <div className="counter-icon bg-primary-transparent">
                                                        <i className="icon-layers text-primary" />
                                                    </div>
                                                    <div className="ms-auto">
                                                        <h5 className="fs-13">Total Trade</h5>
                                                        <h2 className="mb-0 fs-22 mb-1 mt-1">$ {Number(userData.my_stake || 0).toFixed(2)}</h2>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-4 col-md-12">
                                        <div className="card ">
                                            <div className="card-body">

                                                <div className="counter-status d-flex md-mb-0">
                                                    <div className="counter-icon bg-danger-transparent">
                                                        <i className="icon-paypal text-danger" />
                                                    </div>
                                                    <div className="ms-auto">
                                                        <h5 className="fs-13">Total Income</h5>
                                                        <h2 className="mb-0 fs-22 mb-1 mt-1">$ {Number(userData.total_income || 0).toFixed(2)}</h2>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-4 col-md-12">
                                        <div className="card ">
                                            <div className="card-body">
                                                <div className="counter-status d-flex md-mb-0">
                                                    <div className="counter-icon bg-success-transparent">
                                                        <i className="icon-rocket text-success" />
                                                    </div>
                                                    <div className="ms-auto">
                                                        <h5 className="fs-13">Total Withdraw </h5>
                                                        <h2 className="mb-0 fs-22 mb-1 mt-1">$ {Number(userData.withdraw_amount || 0).toFixed(2)}</h2>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="card">
                                    {tabelLoading ? (
                                        <div className="card-body">

                                            <div className="tabs-menu ">
                                                {/* Tabs */}
                                                <ul className="nav nav-tabs profile navtab-custom panel-tabs">
                                                    <li className="">
                                                        <a href="#home" data-bs-toggle="tab" className="active" aria-expanded="true">
                                                            <span className="visible-xs"><i className="las la-key fs-16 me-1" /></span>
                                                            <span className="hidden-xs">TRADE</span>
                                                        </a>
                                                    </li>
                                                    <li className="">
                                                        <a href="#friends01" data-bs-toggle="tab" aria-expanded="false">
                                                            <span className="visible-xs"><i className="las la-life-ring fs-16 me-1" /></span>
                                                            <span className="hidden-xs">DEPOSIT</span>
                                                        </a>
                                                    </li>

                                                    <li className="">
                                                        <a href="#gallery" data-bs-toggle="tab" aria-expanded="false">
                                                            <span className="visible-xs"><i className="las la-images fs-15 me-1" /> </span>
                                                            <span className="hidden-xs">WITHDRAW</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="tab-content border border-top-0 p-4 br-dark">
                                                <div className="tab-pane border-0 p-0 active" id="home">
                                                    <div className="row">
                                                        <div className="table-responsive country-table">
                                                            <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >
                                                                <thead>
                                                                    <tr>
                                                                        <th className="wd-lg-25p">Trade Amt</th>
                                                                        <th className="wd-lg-25p">Daily Reward</th>
                                                                        <th className="wd-lg-25p">Daily Credit</th>
                                                                        <th className="wd-lg-25p">Total Credit</th>
                                                                        <th className="wd-lg-25p">Trade Cap</th>
                                                                        <th className="wd-lg-25p">Income Cap</th>
                                                                        <th className="wd-lg-25p">Direct Income</th>
                                                                        <th className="wd-lg-25p">Level income </th>
                                                                        <th className="wd-lg-25p">Total Income</th>
                                                                        <th className="wd-lg-25p">Trade Age</th>
                                                                        <th className="wd-lg-25p">Trade Date</th>
                                                                        <th className="wd-lg-25p">Last Update</th>
                                                                        <th className="wd-lg-25p">STATUS</th>
                                                                        {/* <th className="wd-lg-25p">ACTION</th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {stakes.length > 0 ? (
                                                                        stakes.map((stake, index) => (
                                                                            <tr>
                                                                                <td><span> ${stake.stake_amount || '0'} </span></td>
                                                                                <td><span>{stake.daily_reward_percentage || '0'} %</span></td>
                                                                                <td><span> $ {stake.daily_credit_reward || '0'} </span></td>
                                                                                <td><span> $ {stake.total_credit || '0'} </span></td>
                                                                                <td><span>$ {stake.stake_capping_value || '0'} </span></td>
                                                                                <td><span>$ {stake.income_capping_value || '0'} </span></td>
                                                                                <td><span>$ {stake.direct_income || '0'} </span></td>
                                                                                <td><span>$ {stake.level_income || '0'} </span></td>
                                                                                <td><span>$ {stake.total_income || '0'} </span></td>
                                                                                <td><span>{stake.stake_age || '0'} Days </span></td>
                                                                                <td><span>{stake.date_time || '0'} </span></td>
                                                                                <td><span>{stake.last_update || '0'} </span></td>
                                                                                <td>
                                                                                    {stake && stake.stake_status
                                                                                        ? stake.stake_status === 'active' ? (
                                                                                            <span className="badge bg-success">Active</span>
                                                                                        ) : (
                                                                                            <span className="badge bg-danger">{stake.stake_status} </span>
                                                                                        ) : 'N/A'}
                                                                                </td>
                                                                                {/* <td><a onClick={() => handleWalletClick(stake.id)} className="btn btn-primary btn-sm"><i className="fa fa-edit"> </i> EDIT </a></td> */}
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td>No Data Found</td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>



                                                        </div>
                                                        {isWalletUpdate && (
                                                            <form onSubmit={updateWalletStatus}>
                                                                <div className="row mt-3 card">
                                                                    <div className="col-12 mt-2">
                                                                        <span>Select Status</span>
                                                                        <select className="form-control" value={status} onChange={(e) => setStatus(e.target.value)}>
                                                                            <option value="">-- Select Status --</option>
                                                                            <option value="enable">Enable</option>
                                                                            <option value="disable">Disable</option>
                                                                        </select>
                                                                    </div>

                                                                    <div className="col-12 mt-2">
                                                                        <span>Service Fees</span>
                                                                        <input type="text" className="form-control" placeholder="Enter Fees" value={fees} onChange={(e) => setFees(e.target.value)} />
                                                                    </div>


                                                                    <div className="col-12 mt-2">
                                                                        <span>Min Withdraw</span>
                                                                        <input type="text" className="form-control" placeholder="Enter Password" value={minWithdraw} onChange={(e) => setMinWithdraw(e.target.value)} />
                                                                    </div>

                                                                    <div className="col-12 mt-2">
                                                                        <span>Max Withdraw</span>
                                                                        <input type="text" className="form-control" placeholder="Enter Password" value={maxWithdraw} onChange={(e) => setMaxWithdraw(e.target.value)} />
                                                                    </div>

                                                                    <div className="col-12 mt-2">
                                                                        <span>Password</span>
                                                                        <input type="password" className="form-control" placeholder="Enter Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                                                    </div>
                                                                    {error && <p className="text-danger mt-2">{error}</p>}

                                                                    <div className="col-12 mt-2 text-end mb-5">
                                                                        <button type="submit" className="btn btn-sm btn-primary">Update</button>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="tab-pane border-0 p-0" id="gallery">
                                                    <div className="row">
                                                        <div className="table-responsive country-table">
                                                            <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >
                                                                <thead>
                                                                    <tr>
                                                                        <th className="wd-lg-25p">Available Amount</th>
                                                                        <th className="wd-lg-25p">Withdraw Amount</th>
                                                                        <th className="wd-lg-25p">Fees Deduct</th>
                                                                        <th className="wd-lg-25p">Paid Amount</th>
                                                                        <th className="wd-lg-25p">Remain Amount</th>
                                                                        <th className="wd-lg-25p">From Address</th>
                                                                        <th className="wd-lg-25p">To Address</th>
                                                                        <th className="wd-lg-25p">Txn Hash</th>
                                                                        <th className="wd-lg-25p">Date Time</th>
                                                                        <th className="wd-lg-25p">Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {withdraws.length > 0 ? (
                                                                        withdraws.map((withdraw, index) => (
                                                                            <tr>

                                                                                <td><span>$ {withdraw.available_amount || '0'} </span></td>
                                                                                <td><span>$ {withdraw.withdraw_amount || '0'} </span></td>
                                                                                <td><span>$ {withdraw.fees_deduction || '0'} </span></td>
                                                                                <td><span>$ {withdraw.paid_amount || '0'} </span></td>
                                                                                <td><span>$ {withdraw.remain_amount || '0'} </span></td>
                                                                                <td><span>{withdraw.from_address || 'N/A'} </span></td>
                                                                                <td><span>{withdraw.to_address || 'N/A'} </span></td>
                                                                                <td><span>{withdraw.txn_hash || 'N/A'}</span></td>
                                                                                <td><span>{withdraw.date_time || '0'}  </span></td>
                                                                                <td>
                                                                                    {withdraw && withdraw.status
                                                                                        ? withdraw.status === 'success' ? (
                                                                                            <span className="badge bg-success">success</span>
                                                                                        ) : (
                                                                                            <span className="badge bg-danger">{withdraw.status} </span>
                                                                                        ) : 'N/A'}
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td>No Data Found</td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>



                                                        </div>
                                                        {isWalletUpdate && (
                                                            <form onSubmit={updateWalletStatus}>
                                                                <div className="row mt-3 card">
                                                                    <div className="col-12 mt-2">
                                                                        <span>Select Status</span>
                                                                        <select className="form-control" value={status} onChange={(e) => setStatus(e.target.value)}>
                                                                            <option value="">-- Select Status --</option>
                                                                            <option value="enable">Enable</option>
                                                                            <option value="disable">Disable</option>
                                                                        </select>
                                                                    </div>

                                                                    <div className="col-12 mt-2">
                                                                        <span>Service Fees</span>
                                                                        <input type="text" className="form-control" placeholder="Enter Fees" value={fees} onChange={(e) => setFees(e.target.value)} />
                                                                    </div>


                                                                    <div className="col-12 mt-2">
                                                                        <span>Min Withdraw</span>
                                                                        <input type="text" className="form-control" placeholder="Enter Password" value={minWithdraw} onChange={(e) => setMinWithdraw(e.target.value)} />
                                                                    </div>

                                                                    <div className="col-12 mt-2">
                                                                        <span>Max Withdraw</span>
                                                                        <input type="text" className="form-control" placeholder="Enter Password" value={maxWithdraw} onChange={(e) => setMaxWithdraw(e.target.value)} />
                                                                    </div>

                                                                    <div className="col-12 mt-2">
                                                                        <span>Password</span>
                                                                        <input type="password" className="form-control" placeholder="Enter Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                                                    </div>
                                                                    {error && <p className="text-danger mt-2">{error}</p>}

                                                                    <div className="col-12 mt-2 text-end mb-5">
                                                                        <button type="submit" className="btn btn-sm btn-primary">Update</button>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="tab-pane border-0 p-0" id="friends01" role="tabpanel">
                                                    <div className="row">
                                                        <div className="table-responsive country-table">
                                                            <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >
                                                                <thead>
                                                                    <tr>
                                                                        <th className="wd-lg-25p">Request Amount</th>
                                                                        <th className="wd-lg-25p">Paid Amount</th>
                                                                        <th className="wd-lg-25p">Deposit With</th>
                                                                        <th className="wd-lg-25p">From Address</th>
                                                                        <th className="wd-lg-25p">To Address</th>
                                                                        <th className="wd-lg-25p">Txn Hash</th>
                                                                        <th className="wd-lg-25p">Date Time</th>
                                                                        <th className="wd-lg-25p">Status </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {deposits.length > 0 ? (
                                                                        deposits.map((deposit, index) => (
                                                                            <tr>
                                                                                <td><span> {deposit.request_amount || '0'} {deposit.deposit_asset} </span></td>
                                                                                <td><span>{deposit.paid_amount || '0'} {deposit.deposit_asset}</span></td>
                                                                                <td><span>  {deposit.deposit_type || 'N/A'} </span></td>
                                                                                <td><span>  {deposit.from_address || 'N/A'} </span></td>
                                                                                <td><span> {deposit.to_address || 'N/A'} </span></td>
                                                                                <td><span> {deposit.txn_hash || 'N/A'} </span></td>
                                                                                <td><span>{deposit.date_time || 'N/A'} </span></td>
                                                                                <td>
                                                                                    {deposit && deposit.status
                                                                                        ? deposit.status === 'success' ? (
                                                                                            <span className="badge bg-success">Success</span>
                                                                                        ) : (
                                                                                            <span className="badge bg-danger">{deposit.status} </span>
                                                                                        ) : 'N/A'}
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td>No Data Found</td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>



                                                        </div>
                                                        {isWalletUpdate && (
                                                            <form onSubmit={updateWalletStatus}>
                                                                <div className="row mt-3 card">
                                                                    <div className="col-12 mt-2">
                                                                        <span>Select Status</span>
                                                                        <select className="form-control" value={status} onChange={(e) => setStatus(e.target.value)}>
                                                                            <option value="">-- Select Status --</option>
                                                                            <option value="enable">Enable</option>
                                                                            <option value="disable">Disable</option>
                                                                        </select>
                                                                    </div>

                                                                    <div className="col-12 mt-2">
                                                                        <span>Service Fees</span>
                                                                        <input type="text" className="form-control" placeholder="Enter Fees" value={fees} onChange={(e) => setFees(e.target.value)} />
                                                                    </div>


                                                                    <div className="col-12 mt-2">
                                                                        <span>Min Withdraw</span>
                                                                        <input type="text" className="form-control" placeholder="Enter Password" value={minWithdraw} onChange={(e) => setMinWithdraw(e.target.value)} />
                                                                    </div>

                                                                    <div className="col-12 mt-2">
                                                                        <span>Max Withdraw</span>
                                                                        <input type="text" className="form-control" placeholder="Enter Password" value={maxWithdraw} onChange={(e) => setMaxWithdraw(e.target.value)} />
                                                                    </div>

                                                                    <div className="col-12 mt-2">
                                                                        <span>Password</span>
                                                                        <input type="password" className="form-control" placeholder="Enter Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                                                    </div>
                                                                    {error && <p className="text-danger mt-2">{error}</p>}

                                                                    <div className="col-12 mt-2 text-end mb-5">
                                                                        <button type="submit" className="btn btn-sm btn-primary">Update</button>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    ) : (
                                        <div className="cord-body">
                                            <div className="text-center">
                                                <div class="d-flex justify-content-center mb-4">
                                                    <div class="spinner-border" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    )}
                                </div>
                            </div>
                        </div>

                        {/* /Table Section */}
                    </div>
                </div>

                <div className="modal fade" id="exampleModal" tabindex="-1"
                    aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel1">Edit Details</h6>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="mt-3">
                                    <label>Name</label>
                                    <input type="text" className="form-control mt-3" name="userName" value={editName} onChange={(e) => setEditName(e.target.value)} />
                                </div>

                                <div className="mt-3">
                                    <label>Email</label>
                                    <input type="text" className="form-control mt-3" name="userName" value={editEmail} onChange={(e) => setEditEmail(e.target.value)} />
                                </div>

                                <div className="mt-3">
                                    <label>Mobile</label>
                                    <input type="text" className="form-control mt-3" name="userName" value={editMobile} onChange={(e) => setEditMobile(e.target.value)} />
                                </div>


                                {error && <p className="text-danger">{error}</p>}
                                <div className="mt-3 text-end">
                                    <button type="submit" onClick={handleSubmit} className="btn btn-primary" disabled={loading}>{loading ? "Uploading..." : "Confirm"}</button>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>


                <ToastContainer />
            </Header>
            <Footer />
        </>
    );
}

export default ClientDetails;
